import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import styles from './field-description.module.css';

type Props = PropsWithChildren<{
  readonly id?: string;
  readonly className?: string;
}>;

export function FieldDescription({id, className, children}: Props) {
  return (
    <p id={id} className={clsx(styles.description, className)}>
      {children}
    </p>
  );
}
